import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePageGoogleChimney.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import AllServicesData from '../ServicesPage/AreaData'
import LocationReviewsData from './LocationReviewsData'
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';

export default function HomePageGoogleChimney({ CitiePhone, locationsMain2Chimney, CitiesData }) {
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);

    const fireMasterCall = () => {
        if (typeof window === "undefined") return;
        if (url.searchParams.get("spg") !== "o") return;
        if (typeof window.oaiq !== "function") return;
        const eventName = "master_chimney_phone_call";
        try {
            window.oaiq("measure", "custom", { type: "custom" }, {
                custom_event_name: eventName,
                event_id: `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            });
        } catch (e) { }
    };

    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [

            {
                "title": "Why Choose Master Chimney Sweep?",
                "content": "With years of experience, we provide professional, reliable chimney sweeping and inspection services, ensuring a safer and more efficient fireplace for your home."
            },
            {
                "title": "What Services Do You Offer?",
                "content": "We offer residential and commercial chimney sweeping, cleaning, inspections, repairs, maintenance, creosote removal, and safety checks to ensure optimal fireplace performance."
            },
            {
                "title": "How Much Is a Chimney Inspection?",
                "content": "Our chimney inspection is only $69, helping to identify potential hazards and necessary repairs before they become serious issues."
            },
            {
                "title": "Can You Clean and Repair at the Same Time?",
                "content": "Yes, we offer same-day chimney cleaning and repairs during your appointment if needed."
            },
            {
                title: `Do you provide services surrounding ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}?`,
                content: `Yes, we don't just serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}! We cover a wide area, including a 75-mile radius around ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}. Whether you're in nearby towns or surrounding areas, we're here to help.`
            },
            {
                "title": "How Do I Book an Appointment?",
                "content": `Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out the <a href='/book${location.search ? location.search + "&service=chimney" : "?service=chimney"}'>online form</a> to schedule your service.`
            }
        ]
    };

    const styles = {
        bgColor: '#f9f1e5',
        titleTextColor: 'white',
        titleTextSize: '18px',
        rowTitleColor: '#0f2d4f',
        rowTitleTextSize: '21px',
        rowContentColor: '#242424',
        rowContentTextSize: '16px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "#0f2d4f",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "Master Air Duct" can help our clients with that kind of chimney and firerplace services, give me that as json file: title 3 words (include in the title words from the keyword, remove null and Master Air Duct from title)(if no keywords just do for chimney and fireplace services) and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);
    return (
        <div className="HomePageGoogleChimney" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Master Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Air Duct Cleaning | Expert Air Duct Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.masterairducts.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Air Duct Cleaning provides top-quality Air Duct cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your Air Duct service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Air Duct Cleaning provides top-quality Air Duct cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your Air Duct service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Air Duct Cleaning" data-react-helmet="true" />
                <meta name="keywords" content="Air Duct Cleaning, Air Duct Inspection, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct services, Air Duct service, Air Duct Inspection, Fireplace Inspection, Fireplace Cleaning, Air Duct Cleaning, Air Duct Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Air Duct Insulation, Air Duct Installation, Air Duct Liner Repair, Air Duct Pointing, Air Duct Rainp Installation, Air Duct Repair, Air Duct Crown Repair, Air Duct Restoration, Air Duct Flue Installation, Air Duct Flue Repair, ​Air Duct Construction, Air Duct Vent Installation, Air Duct Flashing, Flexible Air Duct Liner Installation, Air Duct Damper Repair, Chimneyp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}
            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftLeft">
                        <img src={require(`../../ImagesLogos/Logo1.png`)} />

                    </div>
                    <div className="MainBannerLeftRight">
                        <h1>OUR FAMILY</h1>
                        <h4>SERVING  YOURS!</h4>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <b> Chimney Sweep & Fireplace Inspecion, Cleaning, Repair, Maintenance Near You</b></h2>
                        {/* <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Air Duct & Dryer Vent Cleaning, Repair, Maintenance Near You</h2> */}
                        <h3><img src={require(`../../Images/quality.png`)} alt="Locally Owned & Operated Master Air Duct Cleaning Repair" />Locally Owned & Operated</h3>
                        <h3><img src={require(`../../Images/quality.png`)} alt="Licensed | Bonded | Insured Master Air Duct Cleaning Repair" />Licensed, Bonded, Insured!</h3>
                        <h3><img src={require(`../../Images/quality.png`)} alt="Satisfaction Guaranteed Master Air Duct Cleaning Repair" />Satisfaction Guaranteed</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`} onClick={fireMasterCall}>Call Us Now!</a>
                            <a href={`tel:${CitiePhone}`} onClick={fireMasterCall}>{CitiePhone}</a>
                            <a onClick={() => navigate(`/book${location.search ? location.search + "&service=chimney" : "?service=chimney"}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me Master Air Duct" /></a>
                        </div>
                        <div className="MainBannerLeftImages">
                            <img src={require(`../../Images/YELP.png`)} alt="Master Air Duct Cleaning Cleaning Yelp Review" />
                            <img src={require(`../../Images/Angie.png`)} alt="Master Air Duct Cleaning Cleaning Angie Review" />
                            <img src={require(`../../Images/HomeAdvisor.png`)} alt="Master Air Duct Cleaning Cleaning HomeAdvisor Review" />
                            <img src={require(`../../Images/BBB.png`)} alt="Master Air Duct Cleaning Cleaning BBB Review" />
                            <img src={require(`../../Images/Google.png`)} alt="Master Air Duct Cleaning Cleaning Google Review" />
                            <img src={require(`../../Images/Porch.png`)} alt="Master Air Duct Cleaning Cleaning Porch Review" />
                        </div>

                    </div>

                </div>
            </div>
            {/* BookAnAppointmentMainComponentEmergery */}
            <div className="BookAnAppointmentMainComponentEmergery1" >
                <div className="BookAnAppointmentMainComponentEmergeryBox">
                    <div className="MainBannerLeftRated">
                        <p>Cleaner Chimney, Safer Fireplace. Trust Master Air Duct!</p>

                        <h3>Rated 4.9 on Google</h3>
                        <span>
                            <h4>4.9</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                    {/* <a href={`tel:${CitiePhone}`} onClick={fireMasterCall}> Click To Call: {CitiePhone}</a> */}
                    <img src={require(`../../ImagesLogos/Image1Logo.png`)} />
                </div>
            </div>
            <div className="MainBanner2TopBoxMainChat">
                <img src={require(`../../ImagesLogos/Banner1Logo.png`)} />
                <div className="MainBanner2TopBoxMainChatText">
                    <h4>{response.title}</h4>
                    <h3>{response.body}</h3>
                    <h5>Call us at <a href={`tel:${CitiePhone}`} onClick={fireMasterCall}>{CitiePhone}</a> or fill out the <a href={`/book${location.search ? location.search + "&service=chimney" : "?service=chimney"}`}>online form</a> to schedule your visit.</h5>
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2" id="ourservices">
                <div className="MainBanner2TopBoxMenuShadow1"></div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Chimney9.png`)} alt="Chimney Sweeping" />
                        <h3>Chimney and Fireplace Service</h3>
                        <h2>Keep your home safe and your fireplace efficient with our professional chimney sweeping services.</h2>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Chimney6.jpeg`)} alt="Chimney Cleaning" />
                        <h3>Chimney Cleaning</h3>
                        <h2>Remove soot, creosote buildup, and debris for a safer, cleaner chimney and improved airflow.</h2>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Chimney1.jpeg`)} alt="Chimney Repair" />
                        <h3>Chimney Repair</h3>
                        <h2>From cracks to leaks, our expert chimney repairs restore safety, efficiency, and durability.</h2>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Chimney4.jpeg`)} alt="Chimney Inspection" />
                        <h3>Chimney Inspection</h3>
                        <h2>Our detailed chimney inspections identify potential hazards, ensuring a safe and fully functional chimney.</h2>
                    </a>

                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>

            {/* All home service categories — sub-categories grid */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/service/Dryer-Vent-Cleaning", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            {/* <div className="HomePageGoogleChimneyCoupon" id="off"> */}
            <div className="HomePageGoogleChimneyCoupon" id="off">
                <div className="HomePageGoogleChimneyCouponTop">
                    <div className="HomePageGoogleChimneyCouponText">
                        <h1>Get a Complimentary Estimate</h1>
                        {/* <h1>Get a Complimentary Estimate & Save 10% on All Services!</h1> */}
                        <h2>At Master Air Duct, we believe in delivering top-notch service at a great value. That’s why we offer free estimates for all our services. Whether it’s residential air duct cleaning, commercial duct maintenance dryer vent cleaning, or any repairs you can count on us to provide clear, honest pricing before we start.</h2>
                        <h3>Contact us today to schedule your free estimate and take advantage of this limited-time offer! <a href={`/book${location.search ? location.search + "&service=chimney" : "?service=chimney"}`}>Online appointments available</a></h3>
                    </div>
                    <div className="HomePageGoogleChimneyCouponMain" style={{ "display": "none" }}>
                        <div className="coupon">
                            <div class="left">
                                <div><h3>Enjoy Your Gift</h3></div>
                            </div>
                            <div class="center">
                                <div>
                                    <h2>10% OFF</h2>
                                    <h3>Coupon</h3>
                                    <small>ALL SERVICES</small>
                                </div>
                            </div>
                            <div class="right">
                                <div>MASTER</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/* HomePageGoogleChimneyReviews */}
            <div className="HomePageGoogleChimneyReviews" id="reviews">
                <h1>Trusted by Our Community</h1>
                <div className="HomePageGoogleChimneyReviewsList">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="HomePageGoogleChimneyReviewsBox">
                            <h1>
                                <img src={require(`../../Images/checklist2.png`)} />
                                <img src={require(`../../Images/GoogleIcons.png`)} />
                            </h1>
                            <h3>{A.review}</h3>
                            <div className="HomePageGoogleChimneyReviewsBoxMore">
                                <img src={require(`../../Images/people.png`)} />
                                <span>
                                    <h2>{A.customer}</h2>
                                    <h4>
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                        <img src={require(`../../Images/stars.png`)} />
                                    </h4>
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* MainBanner2 */}
            <div className="MainBanner2" id="about">
                <div className="MainBanner2Left">
                    <div className="MainBanner2TopTopRight">
                        <h4>MASTER YOUR CHIMNEY WITH MASTER CHIMNEY SWEEP!</h4>
                        <h5>It’s more than a service—it’s a commitment to your safety and warmth.</h5>
                        <div className="MainBanner2TopBox">
                            <h2>TRUSTED EXPERTISE</h2>
                            <h3>Since 2001, Master Chimney Sweep has set the standard for chimney services in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> with a reputation built on excellence and years of expertise.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>CLEAR & HONEST PRICING</h2>
                            <h3>No surprises, no gimmicks—just transparent pricing that covers all chimney services, even on holidays.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>FAST & RELIABLE SERVICE</h2>
                            <h3>Need urgent help? We offer same-day and emergency chimney services, 365 days a year, to keep your home safe and warm.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>TOP-TIER QUALITY</h2>
                            <h3>From thorough cleaning to expert repairs, our team uses advanced techniques and state-of-the-art tools for a job done right every time.</h3>
                        </div>

                    </div>

                    {/* Title */}
                    <div className="MainBanner2TopTopBtn">
                        <a href={`tel:${CitiePhone}`} onClick={fireMasterCall}>CALL NOW {CitiePhone}</a>
                        <a onClick={() => navigate(`/book${location.search ? location.search + "&service=chimney" : "?service=chimney"}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning Master| Air Duct Repair Master| Air Duct Services Master| Air Duct Inspection Master" /></a>
                    </div>
                </div>
                <div className="MainBanner2RightRgt">
                    <img src={require(`../../ImagesLogos/Image2Logo.png`)} />

                </div>
            </div>
            {/* HomePageGoogleChimneyBefore */}
            <div className="HomePageGoogleChimneyBefore">
                <h1>Quality Air Duct Cleaning Services</h1>
                <h2>We’re proud to provide community members with the best Air Duct Cleaning and Dryer Vent Cleaning service in the industry. </h2>
                <div className="HomePageGoogleChimneyBeforeImages">
                    <img src={require(`../../Images/Chimney1.jpeg`)} />
                    <img src={require(`../../Images/Chimney2.jpeg`)} />
                    <img src={require(`../../Images/Chimney3.jpeg`)} />
                    <img src={require(`../../Images/Chimney4.jpeg`)} />
                    <img src={require(`../../Images/Chimney5.jpeg`)} />
                    <img src={require(`../../Images/Chimney6.jpeg`)} />
                    <img src={require(`../../Images/Chimney9.png`)} />
                </div>
            </div>
            {/* BookAnAppointment */}
            <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            {/* HomePageGoogleChimneyServices */}
            <div className="HomePageGoogleChimneyServices">
                <div className="MainBanner2TopBoxMenuShadow1">
                    <h3>OUR SERVICES</h3>
                </div>
                <div className="HomePageGoogleChimneyServicesMain">
                    <div className="HomePageGoogleChimneyServicesBox">
                        <div className="HomePageGoogleChimneyServicesBoxLeft">
                            <img src={require(`../../Images/Chimney4.jpeg`)} alt="Chimney Sweeping" />
                        </div>
                        <div className="HomePageGoogleChimneyServicesBoxRight">
                            <h1>Chimney and Fireplace Service</h1>
                            <h2>Keep your chimney in top shape with professional sweeping services! Our experts remove creosote buildup, soot, and debris to ensure safe and efficient fireplace operation.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleChimneyServicesBox">
                        <div className="HomePageGoogleChimneyServicesBoxLeft">
                            <img src={require(`../../Images/Chimney6.jpeg`)} alt="Chimney Cleaning" />
                        </div>
                        <div className="HomePageGoogleChimneyServicesBoxRight">
                            <h1>Chimney and Fireplace Cleaning</h1>
                            <h2>Improve airflow and eliminate fire hazards with our thorough chimney cleaning services. We ensure your fireplace is safe and ready for use.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleChimneyServicesBox">
                        <div className="HomePageGoogleChimneyServicesBoxLeft">
                            <img src={require(`../../Images/Chimney1.jpeg`)} alt="Chimney Repair" />
                        </div>
                        <div className="HomePageGoogleChimneyServicesBoxRight">
                            <h1>Chimney and Fireplace Repair</h1>
                            <h2>Cracked bricks, damaged mortar, or chimney leaks? Our expert repair services restore structural integrity and safety for long-lasting performance.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleChimneyServicesBox">
                        <div className="HomePageGoogleChimneyServicesBoxLeft">
                            <img src={require(`../../Images/Chimney4.jpeg`)} alt="Chimney Inspection" />
                        </div>
                        <div className="HomePageGoogleChimneyServicesBoxRight">
                            <h1>Chimney and Fireplace Inspection</h1>
                            <h2>Stay ahead of potential issues with our detailed chimney inspections. Our professionals identify cracks, creosote buildup, and other risks to keep your home safe.</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleChimneyServicesBox">
                        <div className="HomePageGoogleChimneyServicesBoxLeft">
                            <img src={require(`../../Images/Chimney5.jpeg`)} alt="Chimney Waterproofing" />
                        </div>
                        <div className="HomePageGoogleChimneyServicesBoxRight">
                            <h1>Chimney Waterproofing</h1>
                            <h2>Protect your chimney from water damage and extend its lifespan with our professional waterproofing services. Keep leaks and structural issues at bay!</h2>
                        </div>
                    </div>
                    <div className="HomePageGoogleChimneyServicesBox">
                        <div className="HomePageGoogleChimneyServicesBoxLeft">
                            <img src={require(`../../Images/chimneycap.png`)} alt="Chimney Cap Installation" />
                        </div>
                        <div className="HomePageGoogleChimneyServicesBoxRight">
                            <h1>Chimney Cap Installation</h1>
                            <h2>Prevent animals, debris, and moisture from entering your chimney with a professionally installed chimney cap. A simple upgrade for long-term protection.</h2>
                        </div>
                    </div>
                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>

            {locationsMain2Chimney.find(a => a.Phone == CitiePhone) ?
                <div className="HomePageGoogleChimneyLocation">
                    <div className="HomePageGoogleChimneyLocationBox">

                        <div className="HomePageGoogleChimneyLocationLeft">
                            <h1>Our Service Area / Locations</h1>
                            <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "Your Area"}</b> And Surrounding Areas</h2>
                            <h3>75-Radius Arround {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h3>
                            {locationsMain2Chimney.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                                <div key={index} className="HomePageGoogleChimneyLocationLeftBox">
                                    <h4>{A.Location1}</h4>
                                    <h5>{A.Address1}</h5>
                                    <a href={`tel:${CitiePhone}`} onClick={fireMasterCall}>{CitiePhone}</a>
                                </div>
                            )}
                        </div>
                        <div className="HomePageGoogleChimneyLocationRight">
                            <div className="HomePageGoogleChimneyLocationRightBorder"></div>
                            <iframe src={locationsMain2Chimney.find(a => a.Phone == CitiePhone).Map} ></iframe>
                        </div>
                    </div>

                </div>
                : null}
            {/* MainBanner6 */}
            <div className="MainBanner6" id="contact">
                <div className="MainBanner6Left">
                    <h2>NEED HELP? WE’RE HERE FOR YOU!</h2>
                    <h3>Reach Out to Us Anytime – We're Available 24/7 by Phone for the Fastest Response and a Complimentary Consultation.</h3>
                    <a className="MainBanner6LeftContact" href={`tel:${CitiePhone}`} onClick={fireMasterCall}>{CitiePhone}</a>
                    <div className="MainBanner4FaqMore">
                        <Faq
                            data={data}
                            styles={styles}
                            config={config}
                        />
                    </div>
                </div>
                <div className="MainBanner6Right">
                    <img src={require(`../../ImagesLogos/Logo1.png`)} />
                </div>
            </div>

        </div >
    )
}

